import { render, staticRenderFns } from "./FaqCreate.vue?vue&type=template&id=78d3500c&scoped=true&"
import script from "./FaqCreate.vue?vue&type=script&lang=ts&"
export * from "./FaqCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d3500c",
  null
  
)

export default component.exports